<template>
  <v-autocomplete
    @change="$emit('change', $event)"
    :loading="loading"
    :filter="suggetionFilter"
    :items="items"
    :value="value"
    flat
    hide-no-data
    :placeholder="label"
    :label="label"
    clearable
    item-value="id"
    auto-select-first
    :hint="hint"
    hide-details="auto"
    :persistent-hint="persistentHint"
    :readonly="readonly"
  >
    <template slot="selection" slot-scope="{ item }">
      {{ item.label }}
    </template>
    <template slot="item" slot-scope="{ item }">
      <v-list-item-content>
        <div class="top-row d-flex">
          <div :class="'label' + (isNaN(item.score) ? ' grey--text' : '')">{{ item.label }}</div>
          <div class="percentmatch ml-auto">
            <v-progress-linear
              :value="calcScore(item.score)"
              height="20"
              :color="!isNaN(item.score) ? 'accent' : 'grey'"
            >
              <template v-slot="{ value }">
                <span v-if="!isNaN(item.score)"
                  ><strong>{{ Math.ceil(value) }}%</strong>&nbsp;match</span
                >
                <v-icon small center v-else color="grey darken-1">fa-solid fa-empty-set</v-icon>
              </template>
            </v-progress-linear>
          </div>
        </div>
        <div v-if="item.subLabel" class="bottom-row d-flex">
          <v-tooltip open-delay="500" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="sublabel text-truncate grey--text">{{ item.subLabel }}</div>
            </template>
            <span>{{ item.subLabel }}</span>
          </v-tooltip>
        </div>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  name: 'SuggestionList',
  props: {
    value: {
      type: String,
      description: 'Selected value'
    },
    items: {
      type: Array,
      description: 'Suggestions'
    },
    loading: {
      type: Boolean,
      description: 'Loading indicator',
      default: false
    },
    label: {
      type: String,
      description: 'Label for list',
      default: ''
    },
    hint: {
      type: String,
      description: 'Hint text'
    },
    persistentHint: {
      type: Boolean,
      description: 'Always show hint',
      default: false
    },
    readonly: Boolean
  },
  methods: {
    calcScore(val) {
      if (!val || val < 0) return 0
      else if (val > 1) return 100
      else return val * 100
    },
    suggetionFilter(item, queryText) {
      const text = item.subLabel
        ? `${item.label.toLowerCase()} ${item.subLabel.toLowerCase()}`
        : item.label.toLowerCase()
      const searchText = queryText.toLowerCase()

      return text.indexOf(searchText) > -1
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  max-width: 400px;
}
.sublabel {
  max-width: 400px;
}
.percentmatch {
  width: 150px;
}
.top-row {
  width: 100%;
}
.bottom-row {
  width: 100%;
}
</style>
